import { ImageSize, ImageSizesProps } from '../modernBlocks/modernBlocks.state'
import * as WordPress from '../wordpress/api/types'

//imageName must start with values in image-sizes.php > viddaCrops()
export const parseWordpressImageUrls = (wpImage: WordPress.Image | WordPress.MediaResponse | undefined, imageName?: string): ImageSizesProps => {
  if (imageName == undefined) {
    console.log('--> Pass imageName in convertImageSizesToArray to show image in block')
  }
  if (wpImage == undefined) return { image: undefined }

  let imageSizes: ImageSize[] = []

  const image: any = wpImage.media_details
  const imageRoot: any = wpImage
  
  for (var key in image.sizes) {
    let val: WordPress.ImageSize = image.sizes[key]
    
    if(imageName != undefined && key.startsWith(imageName)) {
      imageSizes.push({ style: undefined, width: val.width, height: val.height, url: val.source_url, validFrontendUrl: true })
     }
  }

  return {
    image: {
      altText: imageRoot.altText, 
      originalImageUrl: image.file, 
      imageSizes: imageSizes
    }
  }
}
